import { Component, Inject,OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DETALLE_BANK } from 'src/app/services/constant-services.data';
import { GlobalService } from 'src/app/services/global/global.service';
@Component({
  selector: 'app-modal-icon-custom',
  templateUrl: './modal-icon-custom.component.html',
  styleUrls: ['./modal-icon-custom.component.scss'],
})
export class ModalIconCustomComponent implements OnInit {
  icon: string;
  bank: any;
  coin: any;
  constructor(
    public globalService: GlobalService,
    public dialogRef: MatDialogRef<ModalIconCustomComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      icon: string
      title: string
      content: string
      bold: string
      cancelbtn: string
      confirmbtn: string
      bullet: any
      coin: string
    }
  ) {}

  ngOnInit() {
    this.bank = DETALLE_BANK
    this.icon= this.data.icon?this.data.icon: 'info'
    this.coin= this.data.coin;

  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel(){
    this.dialogRef.close(false);
  }
}
